import axios from 'axios'
import router from '../router'
import {
	getCookie
} from './cookie'
import {
	Toast
} from 'vant'
import {
	config
} from '../config'
import {
	cache
} from './cache'

const baseURL = process.env.NODE_ENV === 'production' ? '/' : '//localhost:3000/'

// 创建axios实例
let service = axios.create({
	baseURL: baseURL,
	withCredentials: true,
	timeout: 30000 // 请求超时时间
})

// 添加request拦截器
service.interceptors.request.use(config => {
	return config
}, error => {
	Promise.reject(error)
})
// 添加respone拦截器
service.interceptors.response.use(
	response => {
		// console.log(response, response.data.code === 401);
		return response.data
	},
	error => {
		let response = error.response
		if (response.data.code === 401 || response.data.code === 403) {
			router.push({
				path: 'login',
				name: 'login',
				params: {}
			})
			Toast('请先登录')
		} else if (response.data.code !== 0) {
			Toast(response.data.msg || '接口请求失败')
		}
		return Promise.reject(error.response)
	}
)

class Http {
	constructor(needToken = false) {
		this._storageKey = `${config.cache_prefix}`
		this.needToken = needToken
	}

	request({
		url,
		method = 'get',
		data = {}
	}) {
		let axiosConfig = {
			url: config.api_base_url + url,
			method,
			headers: {
				'Content-Type': 'application/json;charset=UTF-8'
			}
		}
		if (this.needToken) {
			axiosConfig.headers.token = cache.session('token')
		}

		switch (method) {
			case 'get':
				axiosConfig.params = data
				break;
			case 'post':
				axiosConfig.data = data
				break;
			case 'put':
				axiosConfig.data = JSON.stringify(data)
				break;
			default:
				break;
		}

		return service(axiosConfig)
		// .catch(err => console.log('catch', err))有问题
	}

	_returnPromise(data) {
		return new Promise((resolve, reject) => {
			resolve(data)
		})
	}
}

export {
	Http
}
